import { createGlide } from "@theme/glide";
import { sliderRegistry } from "@theme/slider-registry";

function initSliders() {
  const sliders = document.querySelectorAll("[data-slider]");

  sliders.forEach((el) => {
    const name = el.dataset.slider;

    if (name === "product") {
      return;
    }

    const speed = el.dataset.speed;
    const baseConfig = sliderRegistry[name];

    if (!baseConfig) {
      console.warn(`Unknown slider config: ${name}`);
      return;
    }

    const config = { ...baseConfig };

    if (speed) {
      config.autoplay = parseInt(speed);
    }

    createGlide(el, config);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSliders);
} else {
  initSliders();
}
